<div class="mx-4 md:mx-6 mb-2">
  <div [ngClass]="{
      'italic': italic,
      'bg-primary/5': showBackground,
      'pt-3': true,
      'text-xs': true,
      'text-gray': true,
      'relative': true
    }">

    <!-- truncated text with read more inline -->
    <span #textEl [ngClass]="!expanded ? 'line-clamp-'+clampLines : ''"
      class="overflow-hidden transition-all duration-300">
      {{ text }}
    </span>

    <!-- inline button -->
    @if (isTruncated) {
      <button (click)="toggle()"
        class="ml-1 text-primary underline cursor-pointer inline-block align-baseline text-xs">
        {{ expanded ? 'Read less' : 'Read more' }}
      </button>
    }
  </div>
</div>